import * as React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Container from 'components/Container';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
import LinkConstants from 'constants/LinkConstants';
import EventTracking from 'lib/EventTracking';

import './styles/PendingGroupPage.scss';

type Props = {
  uuid: string;
  code: string;
  groupName: string;
  groupAvatarUrl: string;
  orgName: string | null;
  onCancelRequest: (groupUuid: string) => void;
};

export default function PendingGroupPage(props: Props) {
  const { code, groupName, groupAvatarUrl, orgName, onCancelRequest, uuid } = props;

  React.useEffect(() => {
    EventTracking.trackKey('request_to_join.pending_group.pending_group_page.view');
  }, []);

  return (
    <div className="PendingGroupPage">
      <Container size="large">
        <Box>
          <BoxBody size="medium">
            <MediaObject>
              <Container className="PendingGroupPage-groupInfo" size="xxsmall">
                <TitleHeader
                  data-test="groupInfo"
                  title={groupName}
                  image={groupAvatarUrl}
                  imageCircle
                  imageSize="xxxsmall"
                  subtext={
                    <React.Fragment>
                      {orgName && <div>{orgName}</div>}
                      {`@${code}`}
                    </React.Fragment>
                  }
                  className="PendingGroupPage-groupName"
                  textAlign="center"
                  size="small"
                  flush
                />
              </Container>
              <Container className="PendingGroupPage-requestInfo" size="xxsmall">
                <TitleHeader
                  title="Your request to join this class has been sent."
                  subtext={
                    <Text>
                      Once a class owner approves, you’ll start receiving class announcements.{' '}
                      <Link
                        className="PendingGroupPage-learnMore"
                        href={LinkConstants.REQUEST_TO_JOIN}
                        weight="semibold"
                        eventElementName="PendingGroupPage-learnMore"
                        eventKey="request_to_join.pending_group.pending_group_page.learn_more.click"
                        target="_blank">
                        Learn more
                      </Link>
                    </Text>
                  }
                  className="PendingGroupPage-title"
                  textAlign="left"
                  size="medium"
                  flush
                  action={
                    <Button
                      eventKey="request_to_join.pending_group.pending_group_page.cancel_request.click"
                      eventElementName="PendingGroupPage-cancel"
                      level="secondary"
                      size="small"
                      weight="semibold"
                      onClick={() => onCancelRequest(uuid)}>
                      Cancel request
                    </Button>
                  }
                />
              </Container>
            </MediaObject>
          </BoxBody>
        </Box>
      </Container>
    </div>
  );
}
